module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal__wrap--bg cmp-modal",
    class: {
      'is-active': _vm.appRejectInfoModal
    },
    attrs: {
      "id": "app-reject-info-template"
    }
  }, [_c('div', {
    staticClass: "modal-wrap-container modal-wd1020"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body-container"
  }, [_c('div', {
    staticClass: "table-wrap no-line-mg"
  }, [_c('table', {
    staticClass: "table-body-only"
  }, [_c('caption', [_vm._v("반려사유 표")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("공고명")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("반려 사유")]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(_vm.rejectInfo) + "\n              ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-secondary btn-md button-wid150 close-modal",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n        닫기\n      ")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-close only-icon close-modal",
    attrs: {
      "type": "button",
      "aria-label": "닫기",
      "title": "닫기"
    },
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "ico ico-x-bl"
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("반려 사유")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', {
    staticClass: "pc-cell"
  }, [_c('col', {
    staticStyle: {
      "width": "160px"
    }
  }), _vm._v(" "), _c('col')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', {
    staticClass: "mo-cell"
  }, [_c('col', {
    staticStyle: {
      "width": "88px"
    }
  }), _vm._v(" "), _c('col')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dc475bf0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/main/member/comp/AppRejectInfo.vue
// module id = 1521
// module chunks = 6